import { useRef, useEffect } from 'react';

function createElementIfRequired(id, doc = document) {
    let element = doc.getElementById(id);
    if (!element) {
        element = doc.createElement('div');
        element.setAttribute('id', id);
        doc.body.appendChild(element);
    }
    return element;
}
/**
 * Create a new element as a body child.
 */
function usePortalElement(_, id = 'modal-element', doc = document) {
    const elementRef = useRef(null);
    elementRef.current = createElementIfRequired(id, doc);
    useEffect(() => {
        elementRef.current = createElementIfRequired(id, doc);
        return () => {
            elementRef.current = doc.getElementById(id);
            if (elementRef.current) {
                doc.body.removeChild(elementRef.current);
                elementRef.current = null;
            }
        };
    }, [doc, id]);
    return elementRef;
}

export { usePortalElement as default };
